<template>
	<div id="enterprise_detail" v-title data-title="发布技术需求">
		<headerbar :curindex="10"></headerbar>
		<div class="">
		 <p class="pageguide centerpage">
		 	<router-link to="/">首页</router-link>&gt;<span>发布{{demandtype1}}</span>
		 </p>
			<div class="release_top centerpage whitebox">
				<div class="rel_title">
					<input placeholder="请输入标题（5-36字）" v-model="title" maxlength="36" /> <span>{{title.length}}/36</span>
				</div>
				<div class="rel_lable" v-if="localusertype == 5">
					<div class="fl">
						<label>所属行业</label>
						<div class="fl leftinput twoselect">
							<select @change="getIndustrylist1(industryid)" v-model="industryid"><option v-for="(item,index) in industrylist" :value="item.value">{{item.name}}</option></select>
							<select v-model="industryid1" v-show="industrylist1.length>0" @change="industryidf=industryid1"><option v-for="(item,index)  in industrylist1" :value="item.value">{{item.name}}</option></select>
						</div> 
					</div>
					<div class="fl">
						<label>所属领域</label>
						<div class="fl leftinput thirdselect">
							<select v-model="notionid" @change="getnotionlistfun(1,notionid)"><option v-for="(item,index) in notionlist" :value="item.value">{{item.label}}</option></select>
							<select v-model="notionid1" @change="getnotionlistfun(2,notionid1)" v-show="notionlist1.length>0"><option v-for="(item,index) in notionlist1" :value="item.value">{{item.label}}</option></select>
							<select v-model="notionid2" v-show="notionlist2.length>0" @change="notionidf=notionid2;"><option v-for="(item,index) in notionlist2" :value="item.value">{{item.label}}</option></select>
						</div>  
					</div>
					<div class="fl">
						<label>技术类型</label>
						<select v-model="techTypeid" class="oneselect"><option v-for="item in techType" :value="item.value">{{item.name}}</option></select>
					</div>
					<div class="fl">
						<label>成熟度</label>
						<select v-model="maturityid" class="oneselect"><option v-for="item in maturity" :value="item.value">{{item.name}}</option></select>
					</div>
					<div class="fl">
						<label>主题分类</label>
						<select v-model="topicTypeid" class="oneselect"><option v-for="item in topicType" :value="item.value">{{item.name}}</option></select>
					</div>
				</div>
				<div class="rel_lable" v-if="localusertype == 2 || localusertype == 3">
					<div class="fl">
						<label>所属行业</label>
						<div class="fl leftinput twoselect">
							<select @change="getIndustrylist1(industryid)" v-model="industryid"><option v-for="(item,index) in industrylist" :value="item.value">{{item.name}}</option></select>
							<select v-model="industryid1" v-show="industrylist1.length>0" @change="industryidf=industryid1"><option v-for="(item,index)  in industrylist1" :value="item.value">{{item.name}}</option></select>
						</div> 
					</div>
					<div class="fl">
						<label>所属领域</label>
						<div class="fl leftinput thirdselect">
							<select v-model="notionid" @change="getnotionlistfun(1,notionid)"><option v-for="(item,index) in notionlist" :value="item.value">{{item.label}}</option></select>
							<select v-model="notionid1" @change="getnotionlistfun(2,notionid1)" v-show="notionlist1.length>0"><option v-for="(item,index) in notionlist1" :value="item.value">{{item.label}}</option></select>
							<select v-model="notionid2" v-show="notionlist2.length>0" @change="notionidf=notionid2;"><option v-for="(item,index) in notionlist2" :value="item.value">{{item.label}}</option></select>
						</div>  
					</div>
					<div class="fl">
						<label>服务类型</label>
						<select v-model="serviceTypeid" class="oneselect"><option v-for="item in serviceType" :value="item.value">{{item.name}}</option></select>
					</div>
					<div class="fl">
						<label>预算</label>
						<div class="fl leftinput budgetinput"><input type="text"  name="budget" id="" v-model="budget" /><span>万元</span></div>
					</div>
					<div class="fl">
						<label>所在地</label>
						<div class="fl leftinput twoselect">
							<select @change="getcitylist(provinceid)" v-model="provinceid"><option v-for="(item,index) in province" :value="item.areaId">{{item.areaName}}</option></select> 
							<select v-model="cityid" v-show="citylist.length>0"><option v-for="(item,index) in citylist" :value="item.areaId">{{item.areaName}}</option></select> 
						</div> 
					</div>
					<div class="fl">
						<label>截止日期</label>
					 <div class="fl enddate"><el-date-picker v-model="enddate" start-placeholder="" value-format="yyyy-MM-dd" :pickerOptions="pickerOptions" type="date" placeholder="选择日期"></el-date-picker></div>
					</div>
				</div> 
			</div>
			<div class="release_bot centerpage whitebox">
				<!-- <textarea></textarea> -->
				<quill-editor v-model="content" :options="editorOption"   ref="content">  </quill-editor>
				<div class="release_btm" @click="turnoption"><span>发布</span></div>
			</div> 
		</div>
		<footerbar></footerbar>
	</div>
</template>

<script>
	import { quillEditor, Quill } from 'vue-quill-editor'
	import $ from "jquery"
	const toolbarOptions = [
		[{'header': [ 2, 3, 4, 5, 6, false]}],
	  ['bold', 'italic', 'underline', 'strike'],
	  // ['blockquote', 'code-block'],
	  [{'list': 'ordered'}, {'list': 'bullet'}],
	  [{'indent': '-1'}, {'indent': '+1'}],
	  // [{'color': []}, {'background': []}],
	  [{'align': []}],
	  // ['link', 'image'],
	  ['clean'],
	  // [{'size': ['small', false, 'large', 'huge']}],
	  
	  // [{'font': []}]
	]
	export default {
		name: 'releasePage',
		data() {
			return { 
				userdata:{},demandtype1:"需求",
				title:"",
				content:"",
				localusertype:5,
				enddate:"",
				pickerOptions:{
					disabledDate(time) {
						return time.getTime() < Date.now();
					},
				},
				editorOption: {
					placeholder: '输入主体内容',
					modules: {
							toolbar: {
									container: toolbarOptions, 
							}
					}
			},
			industrylist:[],//一级行业
			industrylist1:[],//二级行业
			industryid:"",//一级行业ID
			industryid1:"",//二级行业ID
			industryidf:"",//行业ID
			notionlist:[],//一级概念
			notionlist1:[],//二级概念
			notionlist2:[],//三级概念
			notionid:[],//一级概念ID
			notionid1:[],//二级概念ID
			notionid2:[],//三级概念ID
			notionidf:[],//三级概念ID
			maturity:[],//成熟度
			maturityid:"",//成熟度ID
			serviceType:[],//服务类型
			serviceTypeid:"",//服务类型ID
			techType:[],//服务类型
			techTypeid:"",//服务类型ID
			topicType:[],//服务类型
			topicTypeid:"",//服务类型ID
			budget:"",//预算
			province:[],//省份列表
			citylist:[],//城市列表
			provinceid:"",//省份ID
			cityid:"",//城市ID
			}
		}, 
		components: {
					'quill-editor': quillEditor
			},
		beforeCreate() { },
		created() {
			// window.scrollTo(0,0); 
			this.getuserinfor(); 
			
		},
		mounted() {
			window.scrollTo(0, 0);   
		},
		methods: {
			getuserinfor(){
				// this.bus.$emit('loading',true);
				let dataddd=sessionStorage.getItem('userData') ? sessionStorage.getItem('userData'):localStorage.getItem('userData') ;
				if(typeof(dataddd) == 'object'){
				this.userdata = dataddd;
				}else{
				this.userdata = JSON.parse(dataddd);
				}
				this.localusertype = this.userdata.userType; 
				if(this.localusertype == 5){
					this.demandtype="供给";this.demandtype1="技术";
				}else if(this.localusertype == 1 || this.localusertype == 2){
					this.demandtype="需求";this.demandtype1="需求";
				}
				this.getdemandsupply();
			}, 
			getdemandsupply(){
				var _this=this;
				//技术供需用到的参数
				this.$axios.get(this.$api.cyl.parameter.demandsupply(),{headers:{AuthToken:this.userdata.token}}).then(function(res){
					console.log(res.data.data)
					if(res.data.success){    
						_this.industrylist=res.data.data.industry; 
						_this.industryid = _this.industrylist[0].value; 
						_this.maturity=res.data.data.maturity;
						_this.maturityid = _this.maturity[0].value;
						_this.serviceType=res.data.data.serviceType;
						_this.serviceTypeid = _this.serviceType[0].value;
						_this.techType=res.data.data.techType;
						_this.techTypeid = _this.techType[0].value;
						_this.topicType=res.data.data.topicType;
						_this.topicTypeid = _this.topicType[0].value;
					} 
				});
				this.$axios.get(this.$api.tag.notion.list()+"?level=4",{headers:{AuthToken:this.userdata.token}}).then(function(res){ 
					if(res.data.success){    
						// _this.notionlist=res.data.list;  
						var datalist=res.data.list;
						var notionresult=[];
						for(var i=0;i<datalist.length;i++){
							var datalisti=datalist[i].children;
							for(var d=0;d<datalisti.length;d++){
								notionresult.push(datalisti[d]);
							}
						}
						_this.notionlist=notionresult;
						_this.notionid=notionresult[0].value;
						_this.notionidf=notionresult[0].value;
							// console.log(notionresult)
					} 
				});
				this.$axios.get(this.$api.cyl.area.get(),{headers:{AuthToken:this.userdata.token}}).then(function(res){
					console.log(res.data.list)
					if(res.data.success){   
						 _this.province=res.data.list;
							_this.provinceid = _this.province[0].areaId;
					} 
				}) 
			},
			turnoption(){
				// console.log(this.content) ; ''
				var _this=this;
				if(this.title.length<5 || this.content == ""){
					this.$message({
						type: 'error',
						message: '参数不完整',
					});
					return;
				}
				var ajaxdata={
					id:0,title:this.title,
					bIndustry:this.industryid,
					sIndustry:this.industryid1,
					notionCode:this.notionidf,
					summary:this.content 
				};
				
				var ajaxurl="",demandtype="";
				if(this.localusertype == 5){
					//提交供给 多了技术类型 成熟度 主题分类 
					ajaxurl=this.$api.cyl.techsupply.post(); 
					ajaxdata.techType=this.techTypeid;
					ajaxdata.maturity=this.maturityid;
					ajaxdata.topicType=this.topicTypeid;
					demandtype="s";
					
				}else if(this.localusertype == 2 || this.localusertype == 3){
					demandtype="d";
					//提交需求 多了服务类型 预算 所在地 截止日期
					if(this.enddate == "" || this.budget == ""){ 
						this.$message({
							type: 'error',
							message: msgtext,
						});
						return;
					}
					ajaxdata.serviceType=this.serviceTypeid;
					ajaxdata.province=this.provinceid;
					ajaxdata.city=this.cityid;
					ajaxdata.budget=this.budget+'万元';
					ajaxdata.endDate=this.enddate;
					ajaxurl=this.$api.cyl.techdemand.post(); 
				}
				console.log(ajaxurl,ajaxdata);
				$.ajax({
					type:"POST",
					url:ajaxurl,
					data:ajaxdata,
					headers:{AuthToken:this.userdata.token },
					success:function(rew){
						console.log(rew);
						if(rew.success){
							$('.release_btm span').text('发布成功');
							let routeUrl = _this.$router.resolve({
									path: '/demand',query: {type:demandtype,id:rew.data}
							});
							window.open(routeUrl.href);  
						}
					} 
				})
				
				
				 // this.$axios.post(ajaxurl,ajaxdata,{headers:{AuthToken:this.userdata.token}}).then(function(res){
				 // 	console.log(res);
				 	 
				 // }) 
				// console.log(ajaxurl);
				
			},
			//参数获取
			getIndustrylist1(values){
				console.log(values)
				for(var i=0;i<this.industrylist.length;i++){
					let ddvale=this.industrylist[i].value;
					if(ddvale == values){
						 this.industrylist1=this.industrylist[i].children; 
							this.industryid1="";
					}
				};
					this.industryidf=values;
			},
			getcitylist(areaid){ 
				for(var i=0;i<this.province.length;i++){
					let ddvale=this.province[i].areaId;
					if(ddvale == areaid){
						 this.citylist=this.province[i].children; 
							this.cityid='';
					}
				}; 
			}, 
			getnotionlistfun(level,values){
				if(level == 1){
					var biglist=this.notionlist;
				}else if(level == 2){
						var biglist=this.notionlist1;
				}
				for(var i=0;i<biglist.length;i++){
					let ddvale=biglist[i].value;
					if(ddvale == values){
						
						var childrendata=biglist[i].children == null ?[]:biglist[i].children;
						if(level == 1 ){
							this.notionlist1=childrendata; 
							// 	this.notionid1 = this.notionlist1[0].value; 
							this.notionlist2=[];this.notionid2="";
						}else if(level == 2){  
								// this.notionid2 = this.notionlist2[0].value;
							this.notionlist2=childrendata; 
						} 
					}
				} 
				this.notionidf=values;
				
			},
			
		}
	}
</script>

<style>
</style>
